import { clsx } from 'clsx'
import { Fragment, type ComponentPropsWithRef, type ReactElement } from 'react'

import { Row } from '@components/ui-core/row/row'

import { HeroCard } from '@custom/components/hero-card/hero-card'

import { HomepageText } from '../text/homepage-text'

import styles from './mail.module.css'

type MailProps = ComponentPropsWithRef<'div'>

const MAIL_CONTENT = {
  headings: [
    {
      id: 0,
      text: 'Important',
      count: 12,
    },
    {
      id: 1,
      text: 'Calendar',
      count: 13,
    },
    {
      id: 2,
      text: 'Docs',
      count: 8,
    },
    {
      id: 3,
      text: 'Other',
      count: 19,
    },
  ],
  messages: [
    {
      id: 0,
      sender: 'Sarah Kim',
      subject: 'Design Review moved to Thursday',
      preview: "Hey team, quick heads-up — we're pushing the design review to Thursday at 2pm.",
      isSelected: true,
    },
    {
      id: 1,
      sender: 'James Patel',
      subject: 'Feedback on your client presentation',
      preview: 'Great work on the slides. I added a couple of notes around clarity and flow.',
    },
    {
      id: 2,
      sender: 'Laura Chen',
      subject: 'Coffee next week?',
      preview: "It's been a while since we caught up — are you free for a quick coffee next week?",
    },
    {
      id: 3,
      sender: 'HR Team',
      subject: 'Reminder: Open enrollment closes Friday',
      preview: "Don't forget to update your benefits selections before the deadline this week.",
    },
    {
      id: 4,
      sender: 'Mike Torres',
      subject: 'Sprint planning agenda attached',
      preview: 'Please review the agenda ahead of Monday’s sprint planning meeting.',
    },
  ],
}

export function Mail(props: MailProps): ReactElement {
  const { className, ...rest } = props

  const { headings, messages } = MAIL_CONTENT

  return (
    <HeroCard className={clsx(styles.mail, className)} {...rest}>
      <div className={styles.menu}></div>
      {headings.map(heading => (
        <Row crossAxisAlignment="center" gap="1x" key={heading.id}>
          <HomepageText as="span" variant="heroCard">
            {heading.text}
          </HomepageText>
          <HomepageText as="span" variant="heroCard" className={styles.fadedText}>
            {heading.count}
          </HomepageText>
        </Row>
      ))}
      {messages.map(message => (
        <Fragment key={message.id}>
          <div className={clsx(styles.message, message.isSelected && styles.selectedMessage)}></div>
          <HomepageText as="span" variant="heroCard">
            {message.sender}
          </HomepageText>
          <Row
            crossAxisAlignment="center"
            gap="2x"
            key={message.id}
            className={styles.messageContent}
          >
            <HomepageText as="span" variant="heroCard">
              {message.subject}
            </HomepageText>
            <HomepageText as="span" variant="heroCard" className={styles.fadedText}>
              {message.preview}
            </HomepageText>
          </Row>
        </Fragment>
      ))}
    </HeroCard>
  )
}
